import axios from 'axios';
import { AUTH_TOKEN, config } from '@tools/ui/consts';
import { getAuthToken } from '@tools/ui-utils/auth.util';

const getAuthHeaders = (): void => {
  const token = getAuthToken();
  if (token) {
    axios.defaults.headers.common['Authorization'] = token;
  }
};

axios.defaults.baseURL = config.server.baseUrl;
axios.defaults.withCredentials = true;
getAuthHeaders();

const setAuthHeaders = (token?: string): void => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN, token);
    getAuthHeaders();
  }
};

axios.interceptors.response.use((res) => {
  return res.data;
});

export { axios, setAuthHeaders };
